import React from 'react';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { classNames } from '../../../../utils/common/styling.js';
import { styles } from './ModalHeader.styles.js';

var ModalHeader = function (_a) {
    var _b = _a.classes, classes = _b === void 0 ? {} : _b, children = _a.children, hideCloseIcon = _a.hideCloseIcon, onClose = _a.onClose;
    return (React.createElement("div", { className: classNames(styles.root, classes.root) },
        React.createElement("div", { className: classNames(styles.container, classes.container) },
            children,
            !hideCloseIcon ? (React.createElement(CloseRoundedIcon, { className: classNames(styles.close, classes.close), onClick: onClose })) : null)));
};

export { ModalHeader as default };
//# sourceMappingURL=ModalHeader.js.map
